// extracted by mini-css-extract-plugin
export var fadeIn = "_ig-1";
export var modalContent = "_ig-3";
export var overlay = "_ig-0";
export var popoverContent = "_ig-2";
export var results = "_ig-5";
export var searchInputWrapper = "_ig-4";